import {
    BxpWebStargateClient,
    UserProfile
} from "@/libraries/bxp-web-stargate-client/src/index";

import { Environment } from "../";

/**
 * Promisified `/me`, for when using the hook is not applicable
 */

export function requestMe(): Promise<UserProfile> {
    const stargateClient = new BxpWebStargateClient({
        baseUrl: Environment.getApiPrivateUrl()
    });

    return stargateClient.me({});
}

/**
 * Name utilities
 */

export const getFirstName = (fullName = ""): string => {
    return fullName.trim().split(" ")[0] || "";
};

export const getLastName = (fullName = ""): string => {
    let lastName = "";
    const names = fullName.trim().split(" ");

    if (names.length > 1) {
        names.shift();
        lastName = names.join(" ");
    }

    return lastName || ".";
};
